// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"754":"43e9e58339d9d1e1","809":"3fc86010df643471"}[chunkId] + ".js";
};